'use client'

import { useEffect } from 'react'

export function MSWInit() {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_API_MOCKING !== 'enabled') {
      return
    }

    console.log('MSWInit: initializing mocking...')

    async function enableMocking() {
      const { worker } = await import('../mocks/browser')
      await worker.start({
        serviceWorker: {
          url: '/mockServiceWorker.js',
        },
        onUnhandledRequest: 'warn',
      })
    }

    enableMocking().catch((err) => {
      console.error('MSW failed to start:', err)
    })
  }, [])

  return null
}
